import { render, staticRenderFns } from "./ReviewExam.vue?vue&type=template&id=2735caad&scoped=true&"
import script from "./ReviewExam.vue?vue&type=script&lang=js&"
export * from "./ReviewExam.vue?vue&type=script&lang=js&"
import style0 from "./ReviewExam.vue?vue&type=style&index=0&id=2735caad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735caad",
  null
  
)

export default component.exports